import React, { useState } from 'react';
import { Container } from 'rsuite';
import { useParams } from 'react-router-dom';

import BriefView from './view/briefView';

export default function View() {
  return (
    <div className="view">
      <Container>
        <BriefView />
      </Container>
    </div>
  );
}